import { GameSession } from './GameSession'

export const GameSessionList = ({
    sessions,
    showUsername = false,
    openAbove = [],
}: {
    sessions: GameSession[]
    showUsername?: boolean
    openAbove?: string[]
}) => {
    return (
        <table className='border-separate border-spacing-4'>
            <thead className='text-white/50'>
                <tr className='text-left'>
                    <th></th>
                    {showUsername && <th>Player</th>}
                    {/* Deliberately unlabelled: the column is empty on almost
                        every row, and a heading over a column of blanks reads as
                        a missing value rather than an absent flag. */}
                    <th></th>

                    <th></th>
                    <th className=''>Server</th>
                    <th className=''>Spawned</th>
                    <th className=''>Ip</th>
                    <th className=''>Duration</th>
                    <th className=''>Fee</th>
                    <th className=''>Kills</th>
                    <th className=''>Earnings</th>
                    <th>End</th>
                    {/* Beside End rather than near Kills, because it is the
                        other half of the same sentence: the row says the
                        session ended in a death, and this says who by. */}
                    <th>Killed by</th>
                </tr>
            </thead>
            <tbody className='text-xs'>
                {sessions?.map((session, i) => (
                    <GameSession
                        key={i}
                        rowNumber={i}
                        session={session}
                        showUsername={showUsername}
                        openAbove={openAbove}
                    />
                ))}
            </tbody>
        </table>
    )
}
